import React from "react";
import { useTranslation } from "react-i18next";
import IconCar from "../../../dynamicicons/icon-car";
import IconSpeed from "../../../dynamicicons/icon-speed";
import VelavuIconButton from "../../../elements/velavu-icon-button";
import * as styles from "./layers.module.scss";
import whitelabel from "../../../whitelabel";

interface LayersProps {
	showEvents?: boolean;
	setShowEvents: (showSpeeding: boolean) => void;
	showSpeeding?: boolean;
	setShowSpeeding: (showSpeeding: boolean) => void;
}

const colorActive = whitelabel.palette.error900;
const colorInactive = whitelabel.palette.secondary300;

export default function Layers(props: LayersProps) {
	const { t } = useTranslation();

	return (
		<div className={styles.layers}>
			<span className={styles.label}>{t("dashboard.layers.title")}</span>
			<VelavuIconButton
				onClick={() => props.setShowEvents(!props.showEvents)}
				tooltip={t("dashboard.layers.show_driving_events")}
			>
				<IconCar
					color={props.showEvents ? colorActive : colorInactive}
					size={24}
				/>
			</VelavuIconButton>
			<VelavuIconButton
				onClick={() => props.setShowSpeeding(!props.showSpeeding)}
				tooltip={t("dashboard.layers.show_speeding_zones")}
			>
				<IconSpeed
					color={props.showSpeeding ? colorActive : colorInactive}
					size={24}
				/>
			</VelavuIconButton>
		</div>
	);
}
